import React from "react";
import styled from "styled-components";
import gradientBorder from "./GradientBorder";


const HeroSection = styled.section`
  min-height: 100vh;
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 120px 20px 80px;
  background:
    ${({ theme }) => theme.colors.heroOverlay},
    ${({ theme }) => theme.heroBackground};

  @media (min-width: 768px) {
    padding: 160px 40px 120px;
  }
`;

const HeroContent = styled.div`
  text-align: center;
  max-width: 760px;
  animation: fadeUp 1s ease forwards;

  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(30px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

const Heading = styled.h1`
  font-size: 34px;
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: -0.8px;
  color: ${({ theme }) => theme.colors.text};

  @media (min-width: 768px) {
    font-size: 54px;
  }
`;

const Highlight = styled.span`
  display: block;
  margin-top: 8px;
  ${({ theme }) => theme.mixins.smoothGradient};
`;

const Paragraph = styled.p`
  margin: 20px auto 0;
  font-size: 16px;
  line-height: 1.7;
  color: rgba(255,255,255,0.85);
  max-width: 560px;

  @media (min-width: 768px) {
    font-size: 18px;
    margin-top: 30px;
  }
`;

const ButtonContainer = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 14px;

  @media (min-width: 640px) {
    flex-direction: row;
    justify-content: center;
    gap: 20px;
  }
`;

const Button = styled.button`
  padding: 16px 32px;
  font-size: 16px;
  font-weight: 700;
  border-radius: 50px;
  border: none;
  cursor: pointer;
  color: white;
  background: linear-gradient(135deg,#7B3EF0,#F9840A);
  box-shadow: 0 10px 30px rgba(123,62,240,0.35);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 14px 40px rgba(123,62,240,0.5);
  }

  &:active {
    transform: scale(0.96);
  }
`;

export const SecondaryButton = styled.button`
  padding: 14px 30px;
  font-size: 15px;
  font-weight: 700;
  border-radius: 50px;
  border: none;
  cursor: pointer;
  transition: 0.3s ease;

  ${gradientBorder}
`;

const Curve = styled.div`
  position: absolute;
  bottom: -1px;
  width: 100%;
  pointer-events: none;
  overflow: hidden;

  svg {
    width: 100%;
    height: 120px;
  }

  @media (max-width: 768px) {
    svg {
      height: 80px;   /* smaller curve for mobile */
    }
  }
`;

const HeroBanner = () => {
  return (
    <HeroSection>
      <HeroContent>
        <Heading>
          Intelligent Innovation
          <Highlight>Expertise in Technology</Highlight>
        </Heading>

        <Paragraph>
          We help businesses automate, scale and optimize operations using
          AI-powered systems that work 24/7 for you.
        </Paragraph>

        <ButtonContainer>
          <Button>Get Started</Button>
          <SecondaryButton>Contact Us</SecondaryButton>
        </ButtonContainer>
      </HeroContent>

     <Curve>
  <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
    <defs>
      <linearGradient id="heroCurveGradient" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#7B3EF0">
          <animate
            attributeName="stop-color"
            values="#7B3EF0;#C85AD0;#F9840A;#7B3EF0"
            dur="8s"
            repeatCount="indefinite"
          />
        </stop>
        <stop offset="100%" stopColor="#F9840A">
          <animate
            attributeName="stop-color"
            values="#F9840A;#7B3EF0;#C85AD0;#F9840A"
            dur="8s"
            repeatCount="indefinite"
          />
        </stop>
      </linearGradient>
    </defs>

    <path
      d="M0,0 C300,100 900,0 1200,100 L1200,120 L0,120 Z"
      fill="url(#heroCurveGradient)"
    />
  </svg>
</Curve>

    </HeroSection>
  );
};
export default HeroBanner;